
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as indexgvs7WdV1NLBsiIM1p5V4txUPTMYikQ1vfsYYESmgxtgMeta } from "/app/pages/admin/users/index.vue?macro=true";
import { default as _91userId_93P7KYoo_ZKzzwcmBVK4zYB8le3eWJZjjhDo9LGbb_45FgQMeta } from "/app/pages/admin/users/[userId].vue?macro=true";
import { default as adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta } from "/app/pages/admin.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as indexirBOTnaNwmrPfgqxKPc24VhCFOyyli1sfv0vhA8jW_AMeta } from "/app/pages/projects/index.vue?macro=true";
import { default as createOVHESKoZVLNrYpIJtOmwvHotJGbZj3LUiv0Rop782TAMeta } from "/app/pages/projects/create.vue?macro=true";
import { default as indexixOA1831V7kCvoDdWiLWBtll_4595W6Fn_45kTVheM2G7H4Meta } from "/app/pages/projects/[projectSlug]/index.vue?macro=true";
import { default as usersxLT2ik0oCa3jpXQFyU028EODMWu_45cz_dTK8LBqfHl8AMeta } from "/app/pages/projects/[projectSlug]/users.vue?macro=true";
import { default as events8NCG_101XxMCUaQvx3CNvrGEqo1M5Kewh8nbAj9tjCwMeta } from "/app/pages/projects/[projectSlug]/events.vue?macro=true";
import { default as settingskOkdaoOX_VNByJzyR_D8umq_45DaA4C5sD7_qj3D9MqrsMeta } from "/app/pages/projects/[projectSlug]/settings.vue?macro=true";
import { default as _91projectSlug_93VMQ34Vun1OO6JtwEcsabc9nnEpXYVkbtRKGKoaTb2EwMeta } from "/app/pages/projects/[projectSlug].vue?macro=true";
import { default as projectsxh6WAcccXx1FxUw96O427kfQ4qWOYEbrQiw9IivanjMMeta } from "/app/pages/projects.vue?macro=true";
import { default as profile_idBxEjRLwnIn8lX0KM4uycsTe9rVY18SaYz_d_MGewMeta } from "/app/pages/settings/profile.vue?macro=true";
import { default as settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta } from "/app/pages/settings.vue?macro=true";
import { default as loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as registerP6kYPRY6AO3o2k9aPJs1KTHwpt17Hy4EvBog_g8SDPYMeta } from "/app/pages/auth/register.vue?macro=true";
import { default as email9WB9nfPIBIdZnnPmVoMtu853ymJemrsGpYRILFboyccMeta } from "/app/pages/auth/verify/email.vue?macro=true";
import { default as resettqhrzuQ1LO5GF8tYJovWPqmTbrOQE9HfBb5gQU9aQmgMeta } from "/app/pages/auth/password/reset.vue?macro=true";
import { default as recoveryEuCznsBGp2aeP7F0kf2XnxgDgAr35sTKxMSAi72HWzYMeta } from "/app/pages/auth/password/recovery.vue?macro=true";
import { default as _91projectSlug_93_45ir_45YvmC8XWJgewi8Tf2_vSiKyFdB3fPFzZfHPmlcDAMeta } from "/app/pages/auth/invited/[projectSlug].vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta?.name,
    path: "/admin",
    meta: adminHy0fZKw3Hs3Ilpe9PIV9_Obs0tEAeICxhGLuXJq_45_SMMeta || {},
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin",
    path: "",
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin-users",
    path: "users",
    component: () => import("/app/pages/admin/users/index.vue")
  },
  {
    name: "admin-users-userId",
    path: "users/:userId()",
    meta: _91userId_93P7KYoo_ZKzzwcmBVK4zYB8le3eWJZjjhDo9LGbb_45FgQMeta || {},
    component: () => import("/app/pages/admin/users/[userId].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: projectsxh6WAcccXx1FxUw96O427kfQ4qWOYEbrQiw9IivanjMMeta?.name,
    path: "/projects",
    meta: projectsxh6WAcccXx1FxUw96O427kfQ4qWOYEbrQiw9IivanjMMeta || {},
    component: () => import("/app/pages/projects.vue"),
    children: [
  {
    name: "projects",
    path: "",
    component: () => import("/app/pages/projects/index.vue")
  },
  {
    name: "projects-create",
    path: "create",
    component: () => import("/app/pages/projects/create.vue")
  },
  {
    name: _91projectSlug_93VMQ34Vun1OO6JtwEcsabc9nnEpXYVkbtRKGKoaTb2EwMeta?.name,
    path: ":projectSlug()",
    component: () => import("/app/pages/projects/[projectSlug].vue"),
    children: [
  {
    name: "projects-projectSlug",
    path: "",
    component: () => import("/app/pages/projects/[projectSlug]/index.vue")
  },
  {
    name: "projects-projectSlug-users",
    path: "users",
    component: () => import("/app/pages/projects/[projectSlug]/users.vue")
  },
  {
    name: "projects-projectSlug-events",
    path: "events",
    component: () => import("/app/pages/projects/[projectSlug]/events.vue")
  },
  {
    name: "projects-projectSlug-settings",
    path: "settings",
    component: () => import("/app/pages/projects/[projectSlug]/settings.vue")
  }
]
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta || {},
    component: () => import("/app/pages/settings.vue"),
    children: [
  {
    name: "settings-profile",
    path: "profile",
    component: () => import("/app/pages/settings/profile.vue")
  }
]
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta || {},
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registerP6kYPRY6AO3o2k9aPJs1KTHwpt17Hy4EvBog_g8SDPYMeta || {},
    component: () => import("/app/pages/auth/register.vue")
  },
  {
    name: "auth-verify-email",
    path: "/auth/verify/email",
    meta: email9WB9nfPIBIdZnnPmVoMtu853ymJemrsGpYRILFboyccMeta || {},
    component: () => import("/app/pages/auth/verify/email.vue")
  },
  {
    name: "auth-password-reset",
    path: "/auth/password/reset",
    meta: resettqhrzuQ1LO5GF8tYJovWPqmTbrOQE9HfBb5gQU9aQmgMeta || {},
    component: () => import("/app/pages/auth/password/reset.vue")
  },
  {
    name: "auth-password-recovery",
    path: "/auth/password/recovery",
    meta: recoveryEuCznsBGp2aeP7F0kf2XnxgDgAr35sTKxMSAi72HWzYMeta || {},
    component: () => import("/app/pages/auth/password/recovery.vue")
  },
  {
    name: "auth-invited-projectSlug",
    path: "/auth/invited/:projectSlug()",
    component: () => import("/app/pages/auth/invited/[projectSlug].vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/auth",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/login",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/register",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/auth/password",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]